
import { Component, Prop, Vue } from 'vue-property-decorator';
import B2BDeliverySection from '@/components/views/ClientView/B2BDeliverySection.vue';
import AddressLocationFields from '@/components/views/ClientView/AddressLocationFields.vue';

interface B2BDeliveryData {
    phoneNumber: string;
    email: string;
    notes: string;
    deliveryDays: string[];
}

@Component({
    name: 'ClientAddressForm',
    components: {
        B2BDeliverySection,
        AddressLocationFields,
    },
})
export default class ClientAddressForm extends Vue {
    @Prop({ default: null }) private value!: any;
    @Prop({ default: null }) private filteredAddressTypes!: any[];
    @Prop({ default: false }) private isContactAddress!: boolean;
    @Prop({ required: true }) private canAccessLogistics!: boolean;

    private onB2BDeliveryChange(payload: { isB2BDelivery: boolean; data: B2BDeliveryData }) {
        const { isB2BDelivery, data } = payload;
        this.value.b2bDeliveryPhone = isB2BDelivery ? data.phoneNumber : '';
        this.value.b2bDeliveryEmail = isB2BDelivery ? data.email : '';
        this.value.b2bDeliveryNotes = isB2BDelivery ? data.notes : '';
        this.value.b2bDeliveryDays = isB2BDelivery ? (data.deliveryDays?.length ? data.deliveryDays : []) : [];
        this.$emit('input', this.value);
    }
}
